<div class="loading-screen-content-custom">

  <div class="loading-screen-header-custom">
    <h2 class="text-center">{{ 'loading-screen.title-one-moment' | translate }}</h2>
  </div>

  <div class="loading-screen-image-container" @imageAnimation>
    <div class="image"></div>
  </div>

</div>
